export default __webpack_public_path__ + "static/brand-logo-oneills-ddc5ab45c8f23f73a6a054db9d4758f8.png";